
<template>
  <div class="avenue fill-height">
    <div v-if="syncing">
      <v-overlay>
        <div class="loading">
          <v-progress-circular indeterminate size="128"></v-progress-circular>
          <div class="ma-3 loading-text">AVENUE is loading. This may take a few minutes...</div>
        </div>
      </v-overlay>
    </div>
    <div v-else class="fill-height">
      <v-dialog content-class="zoom-image-dialog" v-model="zoomImageDialog" overlay-opacity="0.75">
        <img
          :src="zoomImageUrl"
          style="display: block; width: 95vw; height: 95vh; object-fit: contain;"
          @click="setZoomImageDialog(false)"
        />
      </v-dialog>
      <v-progress-circular
        v-if="allPeople.length"
        indeterminate
        size="50"
        style="position: fixed; right: 10px; bottom: 10px; z-index: 9999; opacity: 0.25;"
      >
        <div v-if="errorCount > 0" style="color: red;">{{errorCount}}</div>
      </v-progress-circular>
      <!--
      <train-debug></train-debug>
      -->
      <v-overlay :value="screensaver" z-index="9999999">
        <v-carousel
          class="fill-height"
          height="100vh"
          style="width: 100vw;"
          hide-delimiters
          :show-arrows="false"
          :interval="config.screensaverTransition * 1000"
          cycle
        >
          <v-carousel-item v-for="(url, i) in config.screensaverUrls" :key="i">
            <div
              style="height: 100vh; width: 100vw; background-color: white;"
              class="d-flex justify-center align-center"
            >
              <img
                :src="url"
                style="max-height: 100vh; max-width: 100vw; height: auto; width: auto;"
              />
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-overlay>

      <v-app-bar class="header" app height="80">
        <v-row no-gutters>
          <v-col class="d-flex justify-start align-center">
            <v-btn icon color="black" @click="clickHome()">
              <div>
                <v-icon large>mdi-home-assistant</v-icon>
                <div class="mt-3">Home</div>
              </div>
            </v-btn>
          </v-col>
          <v-col class="d-flex justify-center align-center">
            <img
              :src="config.logoUrl"
              style="max-height: 70px; max-width: 200px; height: auto; width: auto;"
            />
          </v-col>
          <v-col class="d-flex justify-end align-center">
            <v-text-field
              placeholder="Search..."
              v-model="search"
              outlined
              dense
              hide-details
              class="mr-3"
            ></v-text-field>
            <v-btn icon color="black" @click="clickCatalog()" class="mx-5">
              <div>
                <v-icon large>mdi-view-grid-outline</v-icon>
                <div class="mt-3">Catalog</div>
              </div>
            </v-btn>
            <v-badge color="black" class="mx-5">
              <template v-slot:badge style="border: 1px solid black;">{{clientCart.items.length}}</template>
              <v-btn icon color="black" @click="clickCart()">
                <div>
                  <v-icon large>mdi-cart-outline</v-icon>
                  <div class="mt-3">Cart</div>
                </div>
              </v-btn>
            </v-badge>
          </v-col>
        </v-row>
      </v-app-bar>

      <!-- Sizes your content based upon application components -->
      <v-content class="fill-height">
        <!-- Provides the application the proper gutter -->
        <v-container fluid class="pa-0 fill-height">
          <!-- If using vue-router -->
          <router-view></router-view>
        </v-container>
      </v-content>
      <v-footer
        color="#464646"
        style="display: flex; justify-content: center; align-items: center;"
      >
        <v-menu>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text color="grey darken">
              <v-icon large>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="sync()">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-sync</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span style="margin-right: 10px;">Sync</span>
                  <span style="color: red;">({{timeSinceLastSync}})</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="logoutDialog = true">
              <v-list-item-icon class="mr-2">
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-dialog v-model="logoutDialog" width="500">
          <v-card>
            <v-card-title>Logout</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-3">
              <v-text-field
                label="PIN"
                v-model="logoutPin"
                type="password"
                :error-messages="logoutError"
              ></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="logout()">Logout</v-btn>
              <v-btn color="error" text @click="logoutDialog = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-footer>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import TrainDebug from "../components/TrainDebug.vue";
export default {
  components: {
    TrainDebug
  },
  created: async function() {
    //Fetch Loop
    while (this.loading && this.token) {
      try {
        await this.$store.dispatch("sync");
        this.loading = false;
      } catch (error) {
        alert(error);
      }
    }

    //Idle Events
    document.addEventListener("click", () => this.resetIdle());
    document.addEventListener("keypress", () => this.resetIdle());
    document.addEventListener("mousemove", () => this.resetIdle());

    this.secondInterval = setInterval(() => {
      var oldSyncSeconds = this.$store.state.secondsSinceLastSync;
      var newSyncSeconds = oldSyncSeconds + 1;
      this.idleSeconds += 1;
      this.$store.commit("setSecondsSinceLastSync", newSyncSeconds);
    }, 1000);

    this.scheduleSync();
  },
  destroyed: function() {
    clearInterval(this.secondInterval);
    clearTimeout(this.syncTimeout);
  },
  data: function() {
    return {
      loading: true,
      idleSeconds: 0,
      logoutDialog: false,
      logoutPin: "",
      logoutError: "",
      secondInterval: null,
      syncTimeout: null
    };
  },
  computed: {
    search: {
      get: function() {
        return this.$store.state.search;
      },
      set: _.debounce(function(value) {
        this.$store.commit("setSearch", value);
        this.$store.commit("clearPath");
        this.$store.commit("clearColumnIdToValues");
        this.$router.push(
          `/Manufacturers/${this.$store.state.manufacturerId}/Avenue/Catalog`
        );
      }, 1000)
    },
    errorCount: function() {
      return this.$store.state.errorCount;
    },
    timeSinceLastSync: function() {
      //https://stackoverflow.com/questions/36098913/convert-seconds-to-days-hours-minutes-and-seconds
      var seconds = Number(this.secondsSinceLastSync);

      var d = Math.floor(seconds / (3600 * 24));
      var h = Math.floor((seconds % (3600 * 24)) / 3600);
      var m = Math.floor((seconds % 3600) / 60);
      var s = Math.floor(seconds % 60);

      /*
      var dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      return dDisplay + hDisplay + mDisplay + sDisplay;
      */

      return `${d} d : ${h} h : ${m} m : ${s} s`;
    },
    secondsSinceLastSync: function() {
      return this.$store.state.secondsSinceLastSync;
    },
    syncing: function() {
      return this.$store.state.syncing;
    },
    token: function() {
      return this.$store.state.token;
    },
    allPeople: function() {
      return this.$store.getters.allPeople;
    },
    zoomImageDialog: {
      get: function() {
        return this.$store.state.zoomImageDialog;
      },
      set: function(value) {
        this.$store.commit("setZoomImageDialog", value);
      }
    },
    zoomImageUrl: function() {
      return this.$store.state.zoomImageUrl;
    },
    config: function() {
      return this.$store.state.config;
    },
    screensaver: function() {
      return this.idleSeconds >= this.config.screensaverIdle;
    },
    clientCart: function() {
      return this.$store.getters.clientCart;
    },
    catalogUrl: function() {
      return `/Manufacturers/${this.$route.params.manufacturerId}/Avenue/Catalog`;
    },
    currentNode: function() {
      return this.$store.getters.currentNode;
    },
    filteredGroups: function() {
      return this.$store.getters.filteredGroups;
    }
  },
  methods: {
    //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
    getRandomInt: function(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    scheduleSync: function() {
      console.log("Start Schedule Sync");
      //https://stackoverflow.com/questions/4455282/call-a-javascript-function-at-a-specific-time-of-day
      var currentDate = new Date();
      var targetDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        this.getRandomInt(4),
        this.getRandomInt(60),
        this.getRandomInt(60),
        0
      );

      if (targetDate - currentDate < 0) {
        targetDate.setDate(targetDate.getDate() + 1);
      }

      console.log("Current Date", currentDate);
      console.log("Target Date", targetDate);

      var remainingMillis = targetDate - currentDate;

      console.log("Remaining Milliseconds", remainingMillis);

      this.syncTimeout = setTimeout(() => {
        //Do not sync if in use
        if (this.idleSeconds > 5 * 60) {
          this.$store.dispatch("sync", "nightly-sync");
        }
        this.scheduleSync();
      }, remainingMillis);

      console.log("End Schedule Sync");
    },
    sync: async function() {
      try {
        await this.$store.dispatch("sync");
      } catch (error) {
        alert("Failed to sync");
      }
    },
    setZoomImageDialog: function(value) {
      this.$store.commit("setZoomImageDialog", value);
    },
    resetIdle: function() {
      this.idleSeconds = 0;
    },
    logout: function() {
      if (this.logoutPin.toLowerCase() != "amp") {
        this.logoutError = "Incorrect PIN";
        return;
      }
      this.$store.dispatch("logout");
      this.$router.push("/Login");
    },
    clickHome: function() {
      this.$store.commit("clearPath");
      this.$router.push(
        `/Manufacturers/${this.$store.state.manufacturerId}/Avenue/Path`
      );
    },
    clickCart: function() {
      this.$router.push(
        `/Manufacturers/${this.$store.state.manufacturerId}/Avenue/Cart`
      );
    },
    clickCatalog: function() {
      this.$router.push(
        `/Manufacturers/${this.$store.state.manufacturerId}/Avenue/Catalog`
      );
    }
  },
  watch: {
    filteredGroups: function() {
      this.$store.commit("setPage", 1);
    },
    logoutDialog: function(newValue) {
      if (newValue) return;
      this.logoutPin = "";
      this.logoutError = "";
    }
  }
};
</script>

<style lang="scss">
.zoom-image-dialog {
  &.v-dialog {
    width: auto;
    box-shadow: none;
    max-height: 100vh !important;
  }
}

.ajax-banner {
  background-color: white;
  border: 1px solid black;
  position: fixed;
  margin: 0px;
  padding: 10px;
  bottom: 0px;
  left: 0px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  font-size: 18px;
}
.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .loading-text {
    font-weight: bold;
    font-size: 24px;
  }
}

.v-badge__badge {
  border: 2px solid white;
}
.header {
  color: white !important;
  border-bottom: 1px solid black !important;
}

.v-application {
  background-color: rgb(240, 240, 240) !important;
}
a {
  text-decoration: none;
}
</style>
